import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PATHWAY_CARDS } from "@/lib/nav";
import { T } from "@/constants/testIds";

export default function BeginJourney() {
  return (
    <section data-testid={T.pathwayCards} className="py-20 sm:py-28">
      <div className="container-editorial">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="eyebrow">Begin your journey</span>
            <h2 className="heading-2 mt-3">Wherever you are, there is a next step.</h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {PATHWAY_CARDS.map((card, i) => (
            <Link
              key={card.slug}
              to={card.to}
              data-testid={T.pathwayCard(card.slug)}
              className="group relative bg-paper border border-border p-8 sm:p-10 transition-all hover:border-ink hover:-translate-y-0.5"
            >
              <div className="flex items-start justify-between">
                <span className="eyebrow text-forest">{card.kicker}</span>
                <span className="text-[11px] uppercase tracking-widest text-ink-muted">0{i + 1}</span>
              </div>
              <h3 className="heading-3 mt-4 group-hover:text-forest transition-colors">{card.title}</h3>
              <p className="body-copy mt-4 text-ink-muted">{card.body}</p>
              <div className="mt-8 flex items-center gap-2 text-sm uppercase tracking-widest text-ink group-hover:text-forest">
                {card.cta} <ArrowUpRight className="h-4 w-4" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
